import { useEffect, useState } from "react";
import { getFormPrefill } from "./cookieConsent";

// Returning-visitor auto-fill for contact forms.
//
// Reads the name/email/phone we remembered the last time this visitor submitted
// a contact form (only present if they accepted the "Simplified Forms" cookie
// category). Returns the seed values plus a `filled` flag so a form can show a
// small "welcome back" hint. Also listens for `alfa-consent-change` so that if a
// visitor accepts cookies AFTER the form mounted, any stored details appear
// without a page reload.
export default function useContactPrefill() {
  const [seed, setSeed] = useState({ name: "", email: "", phone: "" });
  const [filled, setFilled] = useState(false);

  useEffect(() => {
    const load = () => {
      const saved = getFormPrefill();
      if (saved && (saved.name || saved.email || saved.phone)) {
        setSeed({
          name: saved.name || "",
          email: saved.email || "",
          phone: saved.phone || "",
        });
        setFilled(true);
      } else {
        setFilled(false);
      }
    };
    load();
    window.addEventListener("alfa-consent-change", load);
    return () => window.removeEventListener("alfa-consent-change", load);
  }, []);

  return { seed, filled };
}
